import { render, staticRenderFns } from "./NumberAdd.vue?vue&type=template&id=73d6dd82&scoped=true&"
import script from "./NumberAdd.vue?vue&type=script&lang=js&"
export * from "./NumberAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d6dd82",
  null
  
)

export default component.exports